<script>
export default {
  data() {
    return {
      items: [
        {
          name: 'admin-account-list',
          title: this.$t('admin.account_list'),
        },
        {
          name: 'admin-account-update-balance-bulk',
          title: this.$t('admin.account_update_balance_bulk'),
        },
      ],
    }
  },
}
</script>

<template>
  <ul :class="$style.localNavigation">
    <router-link
      v-for="{ name, title } in items"
      :key="name"
      :to="{ name, params: $route.params }"
      :active-class="$style.on"
      tag="li"
    >
      <a href="#" @click.prevent>{{ title }}</a>
    </router-link>
  </ul>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
</style>
